import { render, staticRenderFns } from "./QuestionTask.vue?vue&type=template&id=ec6cad44&scoped=true"
import script from "./QuestionTask.vue?vue&type=script&lang=js"
export * from "./QuestionTask.vue?vue&type=script&lang=js"
import style0 from "./QuestionTask.vue?vue&type=style&index=0&id=ec6cad44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6cad44",
  null
  
)

export default component.exports